import Button from 'components/ReusableComponents/Button'
import useCopyText from 'hooks/useCopyText'
import moment from 'moment'
import { useState } from 'react'
import pmsApi from 'services/api/pms'

import styles from './GXPLogin.module.scss'
import { useGXPLogin } from './GXPLoginContext'

export default function UserGeneratedStep() {
  const copy = useCopyText()
  const { data, setActiveStep, pushToData, hasMissingData } = useGXPLogin()
  const [loading, setLoading] = useState(false)

  const handleNext = async () => {
    setLoading(true)
    const res = await pmsApi.updateMarriotGxpConfig({
      activeStep: 'UserWaitingApproval'
    })
    pushToData(res)
    setLoading(false)
    setActiveStep('UserWaitingApproval')
  }

  return (
    <div>
      <p>Request hotel’s PMS contact to create an EID with given credentials.</p>

      <div className={styles.innerCard}>
        <p className={styles.greetingMsg}>
          Hi , Here's the data you can use in order to request/generate an EID.
        </p>
        <div className={styles.mailFields}>
          <p>
            Full Name:<span className={styles.mailField}>{data.fullName}</span>
          </p>
          <p>
            Email:<span className={styles.mailField}>{data.email}</span>
          </p>
          <p>
            Birthdate:
            <span className={styles.mailField}>
              {moment(data.birthOfDate).format('ll')}
            </span>
          </p>
        </div>
        <p>
          These information should help generate the necessary login information. We would
          also receive an email that the access was created. Let me know if you have any
          questions. {data.customerSuccessManagerName || 'Customer Success Team'}{' '}
          Directful, {data.customerSuccessManagerName ? 'Customer Success Manager' : ''}{' '}
          www.directful.com
        </p>
      </div>

      <div className={styles.actions}>
        <Button
          type="secondary"
          onClick={() => copy(data.eMailBody)}
          disabled={hasMissingData}
        >
          Copy email content
        </Button>
        <Button onClick={handleNext} type="primary" disabled={loading || hasMissingData}>
          I've sent the email
        </Button>
      </div>
    </div>
  )
}
